(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-friday-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-products')) {
    customElements.define('bf-products', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;

        this.started = true;
        this.abort = new AbortController();
        this.grid = this.querySelector('[data-grid]');
        this.status = this.querySelector('[data-status]');
        this.category = this.querySelector('[data-category]');
        this.discount = this.querySelector('[data-discount]');
        this.next = this.dataset.next;

        if (new URL(window.location.href).searchParams.has('page')) {
          const first = new URL(window.location.href);
          first.searchParams.set('page', '1');
          this.next = first.href;
        }

        this.ids = new Set(
          [...this.grid.children].map(card => card.dataset.id)
        );

        this.querySelector('fieldset').addEventListener(
          'change',
          () => this.filter()
        );

        this.querySelector('[data-reset]').addEventListener(
          'click',
          () => {
            this.category.value = '';
            this.discount.value = '';
            this.filter();
          }
        );

        this.querySelector('[data-retry]').addEventListener(
          'click',
          () => this.load()
        );

        this.load();
      }

      disconnectedCallback() {
        this.abort?.abort();
      }

      async load() {
        if (this.busy) return;

        this.busy = true;
        this.querySelector('[data-retry]').hidden = true;
        this.status.textContent = this.status.dataset.loading;

        try {
          if (Number(this.dataset.total) > 25000) {
            throw new Error('Pagination limit');
          }

          while (this.next) {
            const url = new URL(
              this.next,
              window.location.origin
            );

            if (url.origin !== window.location.origin) {
              throw new Error('Invalid origin');
            }

            url.searchParams.set(
              'section_id',
              this.dataset.section
            );

            const response = await fetch(url, {
              signal: this.abort.signal
            });

            if (!response.ok) {
              throw new Error('Request failed');
            }

            const doc = new DOMParser().parseFromString(
              await response.text(),
              'text/html'
            );

            const section = [
              ...doc.querySelectorAll('bf-products')
            ].find(
              item => item.dataset.section === this.dataset.section
            );

            if (!section) {
              throw new Error('Missing section');
            }

            const fragment = document.createDocumentFragment();

            section.querySelectorAll('[data-card]').forEach(card => {
              if (!this.ids.has(card.dataset.id)) {
                this.ids.add(card.dataset.id);

                card.querySelectorAll('img').forEach(img => {
                  img.loading = 'lazy';
                });

                fragment.append(card);
              }
            });

            this.grid.append(fragment);

            const next = section.dataset.next;

            if (
              next &&
              new URL(next, url).href ===
                new URL(this.next, url).href
            ) {
              throw new Error('Repeated page');
            }

            this.next = next;
          }

          this.querySelector('[data-pagination]').hidden = true;
          this.querySelector('fieldset').disabled = false;
          this.filter();
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.status.textContent = this.status.dataset.error;
            this.querySelector('[data-retry]').hidden = false;
          }
        } finally {
          this.busy = false;
        }
      }

      filter() {
        let count = 0;

        this.grid.querySelectorAll('[data-card]').forEach(card => {
          const categoryMatch =
            !this.category.value ||
            card.dataset.categories
              .split(/\s+/)
              .includes(this.category.value);

          const discountMatch =
            this.discount.value === '' ||
            card.dataset.bucket === this.discount.value;

          card.hidden = !(categoryMatch && discountMatch);

          if (!card.hidden) count++;
        });

        this.status.textContent =
          `${this.status.dataset.result} ${count}`;

        this.querySelector('[data-empty]').hidden = count > 0;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
